import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getCustomerSales, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportCustomerSalesCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class CustomerSales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `CustomerSalesBeginDate`);
        this.props.formInput(date, `CustomerSalesEndDate`);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.customerSalesBranchOption ? this.props.customerSalesBranchOption.join(",") : this.props.loggedBranch;
        let identificationType = this.props.identificationType || 0;
        let membershipType = this.props.membershipType || 0;
        let identificationNumber = this.props.identificationNumber || "";
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/patientorder?beginDate=${beginDate}&endDate=${endDate}&branchIds=${branch}&identificationType=${identificationType}&identificationNumber=${identificationNumber}&membershipType=${membershipType}`, "customersales");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branchIds = this.props.customerSalesBranchOption ? this.props.customerSalesBranchOption.join(",") : this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        let identificationType = this.props.identificationType || 0;
        let identificationNumber = this.props.identificationNumber || "";
        let membershipType = this.props.membershipType || 0;
        this.props.getCustomerSales({ beginDate, endDate, pageNumber, pageSize, branchIds, membershipType, identificationType, identificationNumber });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.customerSales.length > 0 ? this.props.customerSales[0].totalRows : 0;

        return (
            <Grid headerContent={reportCustomerSalesCrumb}>
                <PageHeader title={LOOKUP.report.customerSales.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-customer-report" />}
                    description={LOOKUP.report.customerSales.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch}
                    branchOptions={this.props.brachOptions}
                    defaultBranch={this.props.defaultBranch}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    isHighTide={this.props.isHighTide}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.customerSales &&
                    <CardSimple>
                        <Body
                            customerSales={this.props.customerSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                            isHighTide = {this.props.isHighTide}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let defaultBranch = [];
    defaultBranch.push({ text: state.common.branchId.toString(), value: state.common.branchId.toString() });
    return {
        brachOptions: brachOptions,
        customerSales: state.reports.customerSales || [],
        loggedBranch: state.common.branchId,
        defaultBranch: defaultBranch,
        beginDate: state.form.CustomerSalesBeginDate,
        endDate: state.form.CustomerSalesEndDate,
        membershipType: state.form.CustomerSalesMembershipType,
        branch: state.form.CustomerSalesBranchOption,
        identificationType: state.form.CustomerSalesIdentificationType,
        AutomationBranchIds: state.form.Locations || ["1"],
        customerSalesBranchOption: state.form.CustomerSalesBranchOption,
        membershipType: state.form.CustomerSalesMembershipType,
        identificationNumber: state.form.CustomerSalesIdentificationNumber,
        isHighTide: state.common.applicationSettings.isHighTide
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCustomerSales: model => dispatch(getCustomerSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CustomerSales));